module.exports = __webpack_public_path__ + "static/media/abs-shp-1.ce8e7658.svg";